"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { useDesktopAnimations } from "@/lib/breakpoints";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
import FeatureGrid, { FeatureGridItem } from "@/components/common/FeatureGrid";
export default function LaravelServices() {
  const $ = _c(15);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      id: "custom-web-dev",
      title: "Custom Laravel Web Development",
      description: "Hire php laravel developers who are experts in developing custom web applications using less effort and codes. Scalable web apps to adjust your growing business needs.",
      icon: "/images/crm/key-benefit-1.png",
      bgColor: "#fdf7fc"
    }, {
      id: "template-design",
      title: "Dynamic Template Design and Integration",
      description: "Hire remote laravel developers to build web applications customized for your enterprise needs at flexible rates for full-time and hourly.",
      icon: "/images/crm/key-benefit-2.png",
      bgColor: "#f3edf9"
    }, {
      id: "api-dev",
      title: "Laravel API Development",
      description: "Need powerful APIs? Hire Laravel programmers to develop secure and efficient APIs for your applications. Our developers ensure smooth data exchange and integration across different platforms.",
      icon: "/images/crm/key-benefit-3.png",
      bgColor: "#fdedef"
    }, {
      id: "cms-dev",
      title: "Laravel CMS Development",
      description: "Our developers create user-friendly, scalable content management systems that simplify website management and enhance content delivery. Hire Laravel developers to provide custom CMS solutions that meet your requirements.",
      icon: "/images/crm/key-benefit-4.png",
      bgColor: "#f1f8ff"
    }, {
      id: "extension-dev",
      title: "Laravel Extension Development",
      description: "Develop high-performing extensions for your application with our experts. Hire Laravel programmers who build modules to extend the capabilities of your existing Laravel project.",
      icon: "/images/crm/key-benefit-5.png",
      bgColor: "#f2f7fd"
    }, {
      id: "integration-support",
      title: "Laravel Integration & Support",
      description: "Our developers create user-friendly, scalable content management systems that simplify website management and enhance content delivery. Hire Laravel developers to provide custom CMS solutions that meet your requirements.",
      icon: "/images/crm/key-benefit-6.png",
      bgColor: "#fefaf6"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const items = t0;
  let t1;
  if ($[1] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      y: [0, -8, 0]
    } : undefined;
    $[1] = desktopAnimations;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== desktopAnimations) {
    t2 = desktopAnimations ? {
      duration: 3.5,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="inline-flex items-center justify-center dark:rounded-full dark:bg-white dark:px-4 dark:py-1.5 dark:shadow-[0_2px_15px_rgba(255,255,255,0.12)]"><Image src="/images/laravel/experts.png" alt="Laravel Experts" width={220} height={48} loading="lazy" className="h-10 sm:h-12 w-auto max-w-[220px] object-contain dark:h-8 dark:max-w-[180px] dark:sm:h-9" onError={_temp} /></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2) {
    t4 = <motion.div animate={t1} transition={t2} className="mb-5 flex items-center justify-center">{t3}</motion.div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span>Custom Laravel Development Services by Industry Experts</span>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <FeatureGrid heading={<div className="flex flex-col items-center">{t4}{t5}</div>} description="As a trusted Laravel development company, we cater to clients across industries and geographies. Reach out for a custom quote and experience our comprehensive, client-focused Laravel development solutions." items={items} raisedColumn={1} />;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative z-10 -mt-6 mb-16 flex justify-center text-center px-4 md:-mt-8 md:mb-20"><GradientButton href="/contact" variant="pink-purple" className="max-w-[calc(100vw-32px)] sm:max-w-none !px-3 sm:!px-8 !text-[12px] min-[360px]:!text-[13.5px] sm:!text-[16px] "><span className="whitespace-nowrap">Hire Laravel Developer For Your Project</span><FaChevronRight className="ml-1 text-[11px] sm:text-[12px] shrink-0" /></GradientButton></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <div className="relative">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp(e) {
  e.currentTarget.src = "/images/shopify/shopify-exprets.png";
}